import { WcgMenuOption } from '@wcg/frontend-framework';

export enum DIALOG_MODES {
  CREATE = 'create',
  EDIT = 'edit',
  EDITNAME = 'editName',
  DELETE = 'delete',
}

export const ADDRESS_LABELS = [
  'address line 1',
  'address line 2',
  'address line 3',
  'city',
];

/** Country labels treated as US/Canada for state dropdown resolution. */
export const US_CANADA_COUNTRY_LABELS = ['united states', 'canada'] as const;

export const DEFAULT_WCG_MENU_OPTIONS: WcgMenuOption = {
  id: '',
  label: '',
};

